var BaseView = require('../sticker/stickersall');

module.exports = BaseView.extend({

  where: { isText: true },
  idPrefix: 'banner'

});
